module.exports = __webpack_public_path__ + "static/media/connection_service_region_2.0a3eccc7.png";